import { render } from "./component-adress-area-name.vue?vue&type=template&id=9828d5f0"
import script from "./component-adress-area-name.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-area-name.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-adress-area-name.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9828d5f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9828d5f0', __exports__)) {
    api.reload('9828d5f0', __exports__)
  }
  
  module.hot.accept("./component-adress-area-name.vue?vue&type=template&id=9828d5f0", () => {
    api.rerender('9828d5f0', render)
  })

}


export default __exports__